import {
    CHANGE_PASSWORD,
    GET_USER,
    RESET_SIGN_IN_ERROR_MESSAGE,
    SIGN_IN,
    SIGN_UP,
    SIGN_OUT,
    LOADING_USER,
    SET_USER_HAS_EVENTS_WITH_PRICING,
    POST_USER,
    GET_USER_FAILED
} from "../actions/type";

const initialState = {
    user: undefined,
    errorMessage: undefined,
    loading: false,
    // El último GET /user terminó con error: el cromo deja el esqueleto y pinta «—».
    userFailed: false
};

const usersReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SIGN_IN:
            return {
                ...state,
                user: payload.Data,
                errorMessage: undefined
            };
        case SET_USER_HAS_EVENTS_WITH_PRICING:
            return {
                ...state,
                user: {
                    ...state.user,
                    hasEventsWithPricing: payload
                }
            }
        case SIGN_UP:
            return {
                ...state,
                user: payload,
                errorMessage: undefined
            };
        case CHANGE_PASSWORD:
            return state;
        case SIGN_OUT:
            return {
                ...state,
                user: undefined,
                errorMessage: undefined,
                userFailed: false
            };
        case GET_USER:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...payload.Data
                },
                errorMessage: undefined,
                userFailed: false
            };
        case POST_USER:
            return {
                ...state,
                user: payload,
                errorMessage: undefined,
                userFailed: false
            };
        case GET_USER_FAILED:
            return {
                ...state,
                userFailed: true
            };
        case RESET_SIGN_IN_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: undefined
            };
        case LOADING_USER:
            return {
                ...state,
                loading: payload
            }
        default:
            return state;
    }
};

export default usersReducer;